import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DotCmsBlogDetailComponent } from '../content-types/dot-cms-uve-blog/dot-cms-uve-blog-detail/dot-cms-uve-blog-detail.component';

const routes: Routes = [{ path: 'page/blog/post/:slug', component: DotCmsBlogDetailComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class DotCmsUveRoutingModule {}
